import React from 'react';
import { Star, Instagram, Facebook, Youtube, Music } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-tx-midnight border-t border-tx-saddle pt-16 pb-8" data-id="element-90">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-10 mb-16" data-id="element-92">
          {/* Brand */}
          <div className="flex flex-col items-center md:items-start" data-id="element-93">
            <a href="#hero" className="flex items-center mb-6" data-id="element-94">
              <img src="https://cdn.magicpatterns.com/uploads/94UtZ6GB3K7UWTyAcnaSfG/footer-header-logo.svg" alt="Texarkana Band Logo" className="h-24 w-auto" data-id="element-95" />
            </a>
            <p className="text-tx-parchmentLight/60 font-body text-center md:text-left max-w-xs" data-id="element-96">
              Southern Rock & Country Cover Band. Bringing the spirit of legends
              to every stage.
            </p>
          </div>

          {/* Contact */}
          <div className="flex flex-col items-center md:items-start" data-id="element-97">
            <h4 className="font-heading text-2xl text-tx-whiskey tracking-widest mb-4 uppercase" data-id="element-98">
              CONTACT
            </h4>
            <a href="mailto:booking@texarkana.com" className="text-tx-parchmentLight/80 hover:text-tx-blue transition-colors font-body mb-2" data-id="element-99">
              booking@texarkana.band
            </a>
            <a href="tel:+528115077138" className="text-tx-parchmentLight/80 hover:text-tx-blue transition-colors font-body" data-id="element-100">
              (81) 1507-7138
            </a>
          </div>

          {/* Socials */}
          <div className="flex flex-col items-center md:items-start" data-id="element-101">
            <h4 className="font-heading text-2xl text-tx-whiskey tracking-widest mb-4 uppercase" data-id="element-102">
              FOLLOW US
            </h4>
            <div className="flex gap-4" data-id="element-103">
              <a href="http://instagram.com/texarkanaband" target="" className="w-12 h-12 rounded-full border border-tx-saddle flex items-center justify-center text-tx-parchmentLight hover:bg-tx-blue hover:border-tx-blue transition-all duration-300" aria-label="Instagram" data-id="element-104">
                <Instagram className="w-5 h-5" data-id="element-105" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-tx-saddle pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-106">
          <p className="text-tx-parchmentLight/40 font-body text-sm" data-id="element-107">
            &copy; {currentYear} Texarkana Band. All rights reserved.
          </p>
          <div className="flex gap-6 text-tx-parchmentLight/40 font-body text-sm" data-id="element-108">
            All rights reserved.
          </div>
        </div>
      </div>
    </footer>;
}